import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../../icon/';

const Action = ({ children, icon, disabled, onClick, actionRef, className, qaId }) => {
  const actionClasses = classNames('uni-btn', 'uni-btn--medium', 'uni-btn--action', {
    'uni-btn--icon-only': children === undefined || null || '',
    [className]: className,
  });

  let buttonIcon;
  if (icon && icon.props) {
    buttonIcon = React.cloneElement(icon, { isButtonIcon: true });
  } else if (icon) {
    buttonIcon = <Icon type={icon} isButtonIcon />;
  }

  return (
    <button className={actionClasses} disabled={disabled} onClick={onClick} ref={actionRef} data-qa-id={qaId}>
      {buttonIcon}
      {children}
    </button>
  );
};

Action.propTypes = {
  children: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  actionRef: PropTypes.func,
  className: PropTypes.string,
  qaId: PropTypes.string,
};

export default Action;



// WEBPACK FOOTER //
// ./src/action-bar/action/index.jsx